import { createFileRoute } from '@tanstack/react-router';
import { NewDeliveryScreen } from '@/features/receiving/DeliveryScreens';

// The palette's "Receive a delivery" (keywords "scan invoice") lands here.
export const Route = createFileRoute('/_app/receiving/new')({
  component: NewDeliveryScreen,
});
